const storeFields = [
  'address(email,formattedAddress,phone)',
  'displayName',
  'formattedDistance',
  'geoPoint',
  'type',
  'url'
];

export const storeSearchFields = [
  'boundNorthLatitude',
  'boundEastLongitude',
  'boundSouthLatitude',
  'boundWestLongitude',
  `stores(${storeFields.join(',')})`
];
